import { useEffect, useState } from "react";
import InputQuantity from "../../../commons/components/InputQuantity/InputQuantity";
import PrimaryButton from "../../../commons/components/PrimaryButton/PrimaryButton";
import { formatPrice } from "../../../commons/utils/functions/formatPrice";
import styles from "./surplus-product-detail-header.module.scss";
import SurplusProductVariants from "../SurplusProductVariants/SurplusProductVariants";

interface SurplusProductDetailHeaderProps {
  images: string[];
  name: string;
  price: number;
  description: string;
  attributes: SurplusProductAttribute[];
  availableQuantity: number;
  selectedVariants: any[];
  setSelectedVariant: (variant: SelectedVariant) => void;
}
const SurplusProductDetailHeader: React.FC<SurplusProductDetailHeaderProps> = ({
  images,
  name,
  price,
  description,
  attributes,
  selectedVariants,
  setSelectedVariant,
  availableQuantity,
}: SurplusProductDetailHeaderProps) => {
  const [currentImage, setCurrentImage] = useState("");
  const [productPrice, setProductPrice] = useState(0);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (selectedVariants.length === 0) {
      setProductPrice(+price);
    } else {
      const getTotalVariantPrice = (variant: any[]) => {
        if (!variant) return 0;

        return variant.reduce((total, price) => {
          return total + +price.price;
        }, 0);
      };

      const newPrice = selectedVariants.reduce(
        (total, variant) => total + getTotalVariantPrice(variant.selectedVariants),
        0
      );

      setProductPrice(newPrice + Number(price));
    }
  }, [selectedVariants, price]);

  useEffect(() => {
    if (images.length > 0) {
      setCurrentImage(images[0]);
    }
  }, [images]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageWrapper}>
        <div className={styles.activeImage}>
          <img src={currentImage} alt="name" />
        </div>
        <div className={styles.smallImages}>
          {images.slice(0, 4).map((image, index) => (
            <img onClick={() => setCurrentImage(image)} src={image} key={index} alt="product" />
          ))}
        </div>
        <div className={styles.description}>
          <div className={styles.label}>Description</div>
          <div className={styles.content}>{description}</div>
        </div>
      </div>
      <div className={styles.info}>
        <div className={styles.nameWrapper}>
          <div className={styles.productName}>{name}</div>

          <div className={styles.price}>{formatPrice(productPrice)}</div>
        </div>

        <SurplusProductVariants
          attributes={attributes}
          selectedVariants={selectedVariants}
          setSelectedVariant={setSelectedVariant}
        />
        <div className={styles.quantityWrapper}>
          <p className={styles.quantityText}>Quantity </p>
          <div className={styles.quantityAvailableWrapper}>
            <InputQuantity quantity={quantity} onChange={setQuantity} max={availableQuantity} />
            <div className={styles.availableQuantity}>{availableQuantity.toLocaleString()} available</div>
          </div>
        </div>
        <PrimaryButton>Add to cart</PrimaryButton>
      </div>
    </div>
  );
};

export default SurplusProductDetailHeader;
